<oth-card [bodyTemplate]="bodyTemplate" class="theme-card" [class.compact]="compact" [class.poster]="!compact && !tile" *ngIf="product">
  <!-- Body -->
  <ng-template #bodyTemplate>

    <!-- Tile card (mobile themes grid): lightest variant, no stats/platforms. -->
    <div class="theme-tile-card" *ngIf="tile"
         [style.--plugin-primary]="product.designTokens?.primaryColor"
         [style.background-image]="product.backgroundImages?.length > 0 ? 'url(' + product.backgroundImages[0].src + ')' : ''"
         (click)="goToTheme()">
      <span class="tile-icon" *ngIf="product.logo">
        <img [src]="product.logo" alt="">
      </span>
      <span class="tile-titles">
        <span class="tile-meta">{{ category }}</span>
        <span class="tile-name">{{ product.name }}</span>
        <div class="tile-divider"></div>
        <span class="tile-meta tile-appearance" *ngIf="product.appearance">{{ product.appearance }}</span>
      </span>
    </div>

    <!-- Compact card (home page themes wall) -->
    <div class="compact-card" *ngIf="compact && !tile"
         [class.priority-bg]="priority"
         [class.compact-centered]="hideMeta"
         [style.background-image]="(!priority && product.backgroundImages?.length > 0) ? 'url(' + product.backgroundImages[0].src + ')' : ''"
         [style.--plugin-primary]="product.designTokens?.primaryColor"
         [style.--plugin-secondary]="product.designTokens?.secondaryColor"
         [style.--plugin-tertiary]="product.designTokens?.tertiaryColor"
         (click)="onCardClick()">
      <!-- LCP element: the centred card's background as a real high-priority
           image (blurred to match the ::before backdrop used by other cards). -->
      <img *ngIf="priority && product.backgroundImages?.length > 0"
           class="compact-card-bg"
           [src]="product.backgroundImages[0].src"
           fetchpriority="high"
           decoding="async"
           alt=""
           aria-hidden="true">
      <div class="compact-inner">
        <svg class="compact-logo" [class.dark]="darkModeActive"
             xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             viewBox="0 0 210 297">
          <defs>
            <linearGradient
              y2="165.93872" x2="224.92535" y1="169.14873" x1="124.6287"
              gradientTransform="matrix(-3.8992867,0,0,3.8992867,887.45881,-514.3054)"
              gradientUnits="userSpaceOnUse"
              [id]="'linearGradient_Compact_' + product.key"
              [attr.xlink:href]="'#Logo_Color_Compact_' + product.key"/>
            <linearGradient
              x1="0" y1="0" x2="1" y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(135.46671,0,0,-135.46671,1268.2878,631.59055)"
              spreadMethod="pad"
              [id]="'Logo_Color_Compact_' + product.key">
              <stop class="stop-theme-color"
                    stop-color="var(--plugin-primary, var(--theme-color))" offset="0"/>
              <stop class="stop-theme-color-secondary"
                    stop-color="var(--plugin-secondary, var(--theme-color-secondary))" offset="1"/>
            </linearGradient>
          </defs>
          <path
            [style.fill]="'url(#linearGradient_Compact_' + product.key + ')'"
            style="fill-opacity:1;stroke:none;stroke-width:4.17227"
            d="m 178.50387,213.25342 c 14.21454,-12.55147 17.57518,-39.48208 6.87786,-55.13809 v 0 c -8.67477,-16.8641 -33.95747,-26.73174 -51.76202,-20.2132 v 0 L 79.25799,83.536554 162.79062,8e-5 102.34432,0 18.32417,83.536554 103.15283,168.36917 c -6.52233,17.80465 3.34909,43.08736 20.21314,51.76217 v 0 c 6.24325,4.26283 14.27194,6.29676 22.47262,6.29676 v 0 c 12.368,0 25.11827,-4.62604 32.66528,-13.17468"/>
        </svg>
        <svg class="compact-logo compact-logo--left" [class.dark]="darkModeActive"
             xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             viewBox="0 0 210 297">
          <defs>
            <linearGradient
              y2="165.93872" x2="224.92535" y1="169.14873" x1="124.6287"
              gradientTransform="matrix(-3.8992867,0,0,3.8992867,887.45881,-514.3054)"
              gradientUnits="userSpaceOnUse"
              [id]="'linearGradient_Compact_Reversed_' + product.key"
              [attr.xlink:href]="'#Logo_Color_Compact_Reversed_' + product.key"/>
            <linearGradient
              x1="0" y1="0" x2="1" y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(135.46671,0,0,-135.46671,1268.2878,631.59055)"
              spreadMethod="pad"
              [id]="'Logo_Color_Compact_Reversed_' + product.key">
              <stop class="stop-theme-color-secondary"
                    stop-color="var(--plugin-secondary, var(--theme-color-secondary))" offset="0"/>
              <stop class="stop-theme-color"
                    stop-color="var(--plugin-primary, var(--theme-color))" offset="1"/>
            </linearGradient>
          </defs>
          <path
            [style.fill]="'url(#linearGradient_Compact_Reversed_' + product.key + ')'"
            style="fill-opacity:1;stroke:none;stroke-width:3.8232"
            d="M 31.496131,83.498219 C 17.281586,96.049685 13.920954,122.9803 24.61827,138.63631 v 0 c 8.67477,16.8641 33.95747,26.73174 51.762024,20.2132 v 0 l 54.361716,54.36558 -83.532627,83.53647 60.446297,8e-5 84.02015,-83.53655 -84.82866,-84.83262 C 113.3695,110.57782 103.49808,85.295107 86.634028,76.620298 v 0 C 80.390777,72.357466 72.362085,70.323536 64.161412,70.323536 v 0 c -12.368001,0 -25.118271,4.626039 -32.665281,13.174683"/>
        </svg>
        <div class="compact-main">
          <div class="compact-header">
            <div class="compact-theme-logo" *ngIf="product.logo">
              <img [src]="product.logo" alt="" class="compact-theme-logo-img">
            </div>
            <div class="compact-titles">
              <p class="compact-category">
                {{ category }}<ng-container *ngIf="product.appearance"><span class="compact-sep">&nbsp;&ndash;&nbsp;</span>{{ product.appearance }}</ng-container>
              </p>
              <h3 class="compact-name">{{ product.name }}</h3>
            </div>
          </div>
          <div class="compact-color-tags">
            <span *ngFor="let color of (product.compactPalette || [])" class="compact-color-dot"
                  [style.background-color]="color"></span>
            <span *ngIf="!(product.compactPalette?.length > 0)" class="compact-color-dot compact-color-dot--multi"></span>
          </div>
          <div class="compact-tags" *ngIf="product.tags?.length > 0">
            <span *ngFor="let tag of (product.tags | slice: 0: 3)" class="compact-tag">{{ tag }}</span>
          </div>
        </div>
        <div class="compact-meta" *ngIf="!hideMeta">
          <div class="compact-stats">
            <!-- Always rendered, matches the banner pattern: loader while
                 stats are being fetched, then the animated count when > 0,
                 or "N/A" when the API returned nothing for this product. -->
            <div class="compact-stat" *ngIf="showDownloads">
              <span class="compact-stat-value">
                <span class="counter-loader-container" *ngIf="product.totalDownloads === undefined">
                  <span class="counter-loader-left"></span>
                  <span class="counter-loader-right"></span>
                  <span class="counter-loader-dots">
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                  </span>
                  <span class="counter-loader-warp-left"></span>
                  <span class="counter-loader-warp-right"></span>
                </span>
                <ng-container *ngIf="product.totalDownloads !== undefined && product.totalDownloads > 0">{{ animatedDownloads || product.downloads }}</ng-container>
                <ng-container *ngIf="product.totalDownloads !== undefined && product.totalDownloads <= 0">N/A</ng-container>
              </span>
              <span class="compact-stat-label">Downloads</span>
            </div>
            <!-- Same loader/value/N-A pattern as Downloads above. -->
            <div class="compact-stat">
              <span class="compact-stat-value">
                <span class="counter-loader-container" *ngIf="product.rating === undefined || product.rating === null">
                  <span class="counter-loader-left"></span>
                  <span class="counter-loader-right"></span>
                  <span class="counter-loader-dots">
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                  </span>
                  <span class="counter-loader-warp-left"></span>
                  <span class="counter-loader-warp-right"></span>
                </span>
                <ng-container *ngIf="product.rating > 0">{{ product.rating | number: '1.1-1' }}</ng-container>
                <ng-container *ngIf="product.rating !== undefined && product.rating !== null && product.rating <= 0">{{ noRatingLabel(product) }}</ng-container>
              </span>
              <span class="compact-stat-label">Rating</span>
            </div>
            <div class="compact-stat">
              <span class="compact-stat-value compact-featured">{{ product.editorialLabel ? product.editorialLabel : 'Curated' }}</span>
              <span class="compact-stat-label">Featured</span>
            </div>
          </div>
          <div class="compact-platforms" *ngIf="getVisiblePlatforms().length > 0">
            <img *ngFor="let platform of getVisiblePlatforms()" [src]="platform.logo"
                 [alt]="platform.name" [title]="platform.name" class="compact-platform-logo">
            <span class="compact-more" *ngIf="getRemainingPlatformsCount() > 0">+{{ getRemainingPlatformsCount() }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Poster card (themes page): the LINE store thumbnail design grown to
         card size, the theme's wallpaper fills the canvas, the round logo
         floats high in its clear area, a same-colour scrim pools at the
         bottom under the identity stack (CATEGORY, APPEARANCE / name / tags)
         and a lone Codigrate logo-half accents the bottom-left corner. -->
    <div class="poster-card" *ngIf="!compact && !tile"
       [style.--plugin-primary]="product.designTokens?.primaryColor"
       [style.--plugin-secondary]="product.designTokens?.secondaryColor"
       [style.--panel]="posterPanel"
       [style.--panel-0]="posterPanel0"
       [style.--poster-fg]="posterFg"
       [style.--poster-fg-dim]="posterFgDim"
       [style.--strip-h]="posterStrip.length ? '56px' : '0px'"
       (click)="onCardClick()">

    <!-- The home wall's centred poster is that page's LCP: priority renders
         it eager + high so the browser fetches it first; everywhere else the
         wallpaper stays lazy. -->
    <img class="poster-bg" *ngIf="product.backgroundImages?.length > 0"
         [src]="product.backgroundImages[0].src" [alt]="product.name"
         [attr.loading]="priority ? 'eager' : 'lazy'"
         [attr.fetchpriority]="priority ? 'high' : null"
         decoding="async">

    <div class="poster-scrim"></div>

    <!-- Lone decorative Codigrate logo half at the bottom-left, in the
         theme's PRIMARY colour (flat - no gradient). -->
    <svg class="poster-part"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 210 297" aria-hidden="true">
      <path
        style="fill:var(--plugin-primary, var(--theme-color));fill-opacity:1;stroke:none;stroke-width:3.8232"
        d="M 31.496131,83.498219 C 17.281586,96.049685 13.920954,122.9803 24.61827,138.63631 v 0 c 8.67477,16.8641 33.95747,26.73174 51.762024,20.2132 v 0 l 54.361716,54.36558 -83.532627,83.53647 60.446297,8e-5 84.02015,-83.53655 -84.82866,-84.83262 C 113.3695,110.57782 103.49808,85.295107 86.634028,76.620298 v 0 C 80.390777,72.357466 72.362085,70.323536 64.161412,70.323536 v 0 c -12.368001,0 -25.118271,4.626039 -32.665281,13.174683"/>
    </svg>

    <!-- Identity stack on the scrim. The logo now flows at the TOP of this
         stack (normal flow, so it moves together with the text below); the
         spacing is tuned with padding/margins, not absolute positioning. -->
    <div class="poster-content">
      <img class="poster-logo" *ngIf="product.logo" [src]="product.logo" alt="">
      <span class="poster-category">{{ category }}<ng-container *ngIf="product.appearance"><span class="poster-dash"></span>{{ product.appearance }}</ng-container></span>
      <h3 class="poster-name">{{ product.name }}</h3>
      <span class="poster-tags" *ngIf="posterTags">{{ posterTags }}</span>
    </div>

    <!-- The color-circle's 5 colours as a strip of adjacent long rectangles
         pinned to the bottom edge; the scrim, corner logo-half and identity
         stack all sit above it. -->
    <div class="poster-strip" *ngIf="posterStrip.length">
      <span class="poster-strip-cell" *ngFor="let color of posterStrip"
            [style.background-color]="color"></span>
    </div>
    </div>
  </ng-template>
</oth-card>
